<template>
  <svg
    class="kds-icon"
    :class="{ 'kds-icon--labelled': !!label }"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="label ? 'img' : undefined"
    :aria-hidden="label ? undefined : 'true'"
    v-html="markup"
  ></svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ICON_PATHS } from '@/kds/tokens';
import type { KdsIconName } from '@/kds/types';

interface Props {
  name: KdsIconName;
  size?: number;
  label?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 16,
  label: undefined
});

// Fallback safety: unknown name renders empty markup, never crashes.
const inner = computed(() => ICON_PATHS[props.name] ?? '');

const titleMarkup = computed(() =>
  props.label ? `<title>${escapeXml(props.label)}</title>` : ''
);

const markup = computed(() => `${titleMarkup.value}${inner.value}`);

function escapeXml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
</script>

<style scoped lang="scss">
.kds-icon {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
  color: inherit;
}
</style>
